<template>
  <span v-if="isOwner">
    <v-btn icon class="white--text" title="Szukaj globalnie (wszystkie firmy)" @click="openDialog">
      <v-icon>mdi-database-search</v-icon>
    </v-btn>
    <v-dialog v-model="open" max-width="700px" scrollable>
      <v-card>
        <v-card-title>
          <v-icon left color="primary">mdi-database-search</v-icon>
          Szukaj globalnie — wszystkie firmy
          <v-spacer></v-spacer>
          <v-btn icon @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            ref="qInput"
            v-model="q"
            placeholder="Kierowca, auto, tablica, e-mail, administrator…"
            prepend-inner-icon="mdi-magnify"
            outlined dense hide-details clearable
            :loading="loading"
            @input="onType"
          ></v-text-field>

          <div v-if="searched && isEmpty" class="grey--text text-center my-6">Brak wyników.</div>

          <template v-if="results.drivers.length">
            <div class="gs-grp">Kierowcy ({{ results.drivers.length }})</div>
            <div v-for="d in results.drivers" :key="'d' + d.id" class="gs-row">
              <div class="gs-info">
                <b>{{ d.name }}</b>
                <div class="gs-meta">{{ d.phone }}<span v-if="d.companyName"> · {{ d.companyName }}</span></div>
              </div>
              <v-btn x-small outlined color="indigo" :loading="busyId === d.id" @click="impersonateDriver(d)">
                <v-icon x-small left>mdi-cellphone-key</v-icon>Wejdź jako
              </v-btn>
            </div>
          </template>

          <template v-if="results.cars.length">
            <div class="gs-grp">Auta ({{ results.cars.length }})</div>
            <div v-for="c in results.cars" :key="'c' + c.id" class="gs-row">
              <div class="gs-info">
                <b>{{ c.plate }}</b> <span class="gs-meta">{{ c.label }}</span>
                <div class="gs-meta">{{ c.companyName }}<span v-if="!c.isCompanyCar"> · prywatne</span></div>
              </div>
              <div class="d-flex" style="gap:6px">
                <v-btn v-if="!c.isCompanyCar" x-small color="success" :loading="busyId === c.id" @click="makeCompanyCar(c)">
                  <v-icon x-small left>mdi-domain</v-icon>Na firmowe
                </v-btn>
                <v-btn x-small outlined :loading="busyId === c.id" @click="switchTo(c.companyId, c.companyName, c.id)">
                  <v-icon x-small left>mdi-office-building-marker</v-icon>Przełącz na firmę
                </v-btn>
              </div>
            </div>
          </template>

          <template v-if="results.admins.length">
            <div class="gs-grp">Administratorzy ({{ results.admins.length }})</div>
            <div v-for="a in results.admins" :key="'a' + a.id" class="gs-row">
              <div class="gs-info">
                <b>{{ a.name }}</b>
                <div class="gs-meta">{{ a.email }}<span v-if="a.companyName"> · {{ a.companyName }}</span> · {{ a.role }}</div>
              </div>
              <v-btn x-small outlined color="indigo" :loading="busyId === a.id" @click="impersonateAdmin(a)">
                <v-icon x-small left>mdi-account-switch</v-icon>Wejdź jako
              </v-btn>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import Swal from 'sweetalert2'
const axios = require('axios')

export default {
  name: 'GlobalSearch',
  data() {
    return {
      open: false,
      q: '',
      loading: false,
      searched: false,
      busyId: null,
      timer: null,
      results: { drivers: [], cars: [], admins: [] },
    }
  },
  computed: {
    isOwner() {
      try {
        const t = localStorage.getItem('token')
        if (!t) return false
        const p = JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
        const u = p.user || p
        // TYLKO właściciel (headadmin) — bez isHead/hasAccessToAllCompanies
        return u.actualRole === 'headadmin'
      } catch (e) {
        return false
      }
    },
    isEmpty() {
      return !this.results.drivers.length && !this.results.cars.length && !this.results.admins.length
    },
  },
  methods: {
    openDialog() {
      this.open = true
      this.$nextTick(() => { try { this.$refs.qInput.focus() } catch (e) { /* ignore */ } })
    },
    onType() {
      clearTimeout(this.timer)
      this.timer = setTimeout(this.search, 300)
    },
    async search() {
      const q = (this.q || '').trim()
      if (q.length < 2) {
        this.results = { drivers: [], cars: [], admins: [] }
        this.searched = false
        return
      }
      this.loading = true
      try {
        const res = await axios({
          method: 'get',
          url: process.env.VUE_APP_ROOT_API + 'global-search?q=' + encodeURIComponent(q),
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
        this.results = (res.data && res.data.data) || { drivers: [], cars: [], admins: [] }
        this.searched = true
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async impersonateAdmin(a) {
      this.busyId = a.id
      try {
        const res = await axios({
          method: 'post',
          url: process.env.VUE_APP_ROOT_API + 'admin-auth/impersonate/admin/' + a.id,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
        const d = res.data
        localStorage.setItem('token', d.access_token)
        localStorage.setItem('role', d.role)
        localStorage.setItem('actualRole', d.actualRole || d.role || '')
        localStorage.setItem('isHead', String(!!d.isHead))
        localStorage.setItem('pages', JSON.stringify(d.pages || []))
        localStorage.setItem('pagesWithEdit', JSON.stringify(d.pagesWithEdit || []))
        if (d.companyId) localStorage.setItem('activeCompanyId', d.companyId)
        if (d.companyName) localStorage.setItem('activeCompanyName', d.companyName)
        window.location.href = '/'
      } catch (e) {
        this.busyId = null
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się wejść na konto', 'error')
      }
    },
    async impersonateDriver(dr) {
      this.busyId = dr.id
      try {
        const res = await axios({
          method: 'post',
          url: process.env.VUE_APP_ROOT_API + 'admin-auth/impersonate/driver/' + dr.id,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
        const token = res.data && res.data.access_token
        const base = process.env.VUE_APP_DRIVER_URL
        if (!base) {
          Swal.fire('Brak konfiguracji', 'Ustaw VUE_APP_DRIVER_URL (adres aplikacji kierowcy).', 'warning')
          return
        }
        window.open(base.replace(/\/$/, '') + '/?impersonationToken=' + encodeURIComponent(token), '_blank', 'noopener')
      } catch (e) {
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się wejść na konto kierowcy', 'error')
      } finally {
        this.busyId = null
      }
    },
    async makeCompanyCar(c) {
      const r = await Swal.fire({
        title: 'Zmienić na auto firmowe?',
        text: `${c.plate}${c.label ? ' — ' + c.label : ''}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Tak, na firmowe',
        cancelButtonText: 'Anuluj',
        confirmButtonColor: '#1B9E4B',
      })
      if (!r.isConfirmed) return
      this.busyId = c.id
      try {
        await axios({
          method: 'post',
          url: process.env.VUE_APP_ROOT_API + 'cars/restore-as-company/' + c.id,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
        this.$set(c, 'isCompanyCar', true)
        Swal.fire({ title: 'Ustawiono jako firmowe', icon: 'success', timer: 1400, showConfirmButton: false })
      } catch (e) {
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się zmienić na firmowe', 'error')
      }
      this.busyId = null
    },
    async switchTo(companyId, companyName, marker) {
      this.busyId = marker
      try {
        const res = await axios({
          method: 'post',
          url: process.env.VUE_APP_ROOT_API + 'admin-auth/switch-company/' + companyId,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
        if (res.data && res.data.access_token) {
          localStorage.setItem('token', res.data.access_token)
          localStorage.setItem('activeCompanyId', companyId)
          if (companyName) localStorage.setItem('activeCompanyName', companyName)
          window.location.href = '/fleet'
        }
      } catch (e) {
        this.busyId = null
        Swal.fire('Błąd', e.response?.data?.message?.toString() || 'Nie udało się przełączyć firmy', 'error')
      }
    },
  },
}
</script>

<style scoped>
.gs-grp {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #6E7691;
  margin: 16px 0 6px;
  letter-spacing: 0.04em;
}
.gs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid #2A3142;
  border-radius: 8px;
  margin-bottom: 6px;
}
.gs-info { min-width: 0; }
.gs-meta { font-size: 12px; color: #9AA1B0; }
</style>
